import styled from 'styled-components';
import { OnlineThemeType } from '../../themes/online';

const login = (isLogin: boolean, theme: OnlineThemeType) => {
  if (isLogin) {
    return `
      border: none;
      border-bottom: 1px solid ${theme.colors.grayLight2};
      border-radius: 0px;
      padding-left: ${theme.spacing.larger + 5}px;
      padding-bottom: 0px;
      line-height: 1.76;
      `;
  }
  return '';
};

export const SLoginIconField = styled.span<{ icon: string }>(({ theme, icon }) => {
  return `
    position: relative;
    
    &:before {
      content: url(${icon});
      background-repeat: no-repeat;
      backgorund-size: contain;
      position: absolute;
      top: -7px;
      left: 5px;
    }
    `;
});

export const SInput = styled.input<{
  isLogin: boolean;
  backgroundColor: string;
  error: string;
}>(({ theme, isLogin, backgroundColor, error }) => {
  return `
    font-size: ${theme.font.size.smallMedium3};
    font-weight: ${theme.font.weight.light};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.18;
    border-radius: 4px;
    letter-spacing: normal;
    box-sizing: border-box;
    width: 100%;
    border: solid ${error ? `${theme.colors.error} 1.5px` : `${theme.colors.inputBorder} 1px`};
    padding: ${theme.spacing.mediumLarger}px;
    color: ${theme.colors.grayLight2};
    ${login(isLogin, theme)};
    background-color: ${backgroundColor};

    &::placeholder {
      opacity: 0.4;
    }
    `;
});
